import Dashboard from '@/views/dispatcher/Dashboard.vue';
import OnboardingPacket from '@/views/carrier/OnboardingPacket.vue';
import RequestPermission from '@/views/signup/dispatcher/RequestPermission.vue';
import DispatcherGeneralInformation from '@/views/signup/dispatcher/DispatcherGeneralInformation.vue';
import OnboardingComplete from '@/views/dispatcher/OnboardingComplete.vue';
import CompleteHoldingTank from '@/components/holding-tanks/OnboardingComplete.vue';
import SelectCarrier from '@/views/dispatcher/SelectCarrier.vue';
import JoinCarrier from '@/views/dispatcher/JoinCarrier.vue';
import OnboardingPacketStatus from '@/views/common/OnboardingPacketStatus.vue';
import DoNotDispatchHoldingTank from '@/views/common/DoNotDispatchHoldingTank.vue';
import AccountOverview from '@/views/dispatcher/portal/AccountOverview.vue';
import AddCarrier from '@/views/dispatcher/AddCarrier.vue';
import RequestAccess from '@/views/dispatcher/RequestAccess.vue';
import AccessPending from '@/views/dispatcher/AccessPending.vue';
import AwaitingApprovalCases from '@/components/holding-tanks/AwaitingApprovalCases.vue';

export default [
  {
    path: '/dispatcher',
    name: 'Dispatcher Dashboard',
    component: Dashboard,
    meta: { pageTitle: 'Dispatcher Dashboard' },
  },
  {
    path: '/dispatcher/onboarding_packets/:id',
    name: 'Dispatcher Onboarding Packet',
    component: OnboardingPacket,
    meta: { pageTitle: 'Onboarding Packet' },
  },
  // This alias will be used to allow the Dispatcher
  //  component to function as a request access form by hiding certain fields. This will primarily be useful for IDV. Please refer to this flow:
  // https://www.figma.com/design/YR3kEpvEOaj1nLY9D1iPxx/Design-Assets?node-id=1346-13524&node-type=frame&t=ClUpBKiCwGlszM3P-0
  {
    path: '/sign-up/dispatcher/general-information',
    alias: '/sign-up/dispatcher/request-access-general-information',
    name: 'DispatcherGeneralInformation',
    component: DispatcherGeneralInformation,
    meta: { doesNotRequireCompletedUser: true, doesNotRequireCompany: true },
  },
  {
    path: '/sign-up/dispatcher/request-permission',
    name: 'RequestPermission',
    component: RequestPermission,
  },
  {
    path: '/dispatcher/onboarding-complete',
    name: 'OnboardingComplete',
    component: OnboardingComplete,
  },
  {
    path: '/dispatcher/connection-complete',
    name: 'Complete Holding Tank',
    component: CompleteHoldingTank,
  },
  {
    path: '/dispatcher/select-carrier',
    name: 'SelectCarrier',
    component: SelectCarrier,
  },
  {
    path: '/dispatcher/join-carrier',
    name: 'JoinCarrier',
    component: JoinCarrier,
  },
  {
    path: '/dispatcher/onboarding_packets/:id/status',
    name: 'Dispatcher Onboarding Packet Status',
    component: OnboardingPacketStatus,
    meta: { pageTitle: 'Onboarding Packet Status' },
  },
  {
    path: '/dispatcher/holding-tank/blocked-dispatch',
    name: 'Dispatcher Do Not Dispatch Holding Tank',
    component: DoNotDispatchHoldingTank,
    meta: { pageTitle: 'Held By Broker' },
  },
  {
    path: '/dispatcher/account-overview',
    name: 'AccountOverview',
    component: AccountOverview,
    meta: { pageTitle: 'AccountOverview' },
  },
  {
    path: '/dispatcher/add-carriers',
    name: 'Add Carriers',
    component: AddCarrier,
    meta: { pageTitle: 'Add Carriers' },
  },
  {
    path: '/dispatcher/request-access',
    name: 'Request Access',
    component: RequestAccess,
    meta: { pageTitle: 'Request Access' },
  },
  {
    path: '/dispatcher/access-pending',
    name: 'Access Pending',
    component: AccessPending,
    meta: { pageTitle: 'Access Pending' },
  },
  {
    path: '/dispatcher/awaiting-approval/:messageId',
    name: 'Awaiting Approval',
    component: AwaitingApprovalCases,
    meta: { pageTitle: 'Awaiting Approval' },
  },
];
